import React from 'react';
import { StyledFilterPill } from './styles/FilterPill.styles';
import { Icon } from '@vfuk/core-icon';
import { css } from 'styled-components';
import { ContentfulFilters } from './types/SectionFilterableArticles.types';

type FilterPillProps<T extends ContentfulFilters[number]> = {
  item: T;
  removeItemFromFilterList: (item: T) => void;
};

const FilterPill = <T extends ContentfulFilters[number]>({
  item,
  removeItemFromFilterList,
}: FilterPillProps<T>) => {
  return (
    <StyledFilterPill>
      {item.displayName}

      <div
        css={css`
          cursor: pointer;
        `}
        onClick={() => removeItemFromFilterList(item)}
      >
        <Icon name="close" size={1} />
      </div>
    </StyledFilterPill>
  );
};

export default FilterPill;
